import {
  createPlugin,
  createComponentExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

import {
  shouldRenderHerokuInfo,
  shouldRenderPagerDutyInfo,
  shouldRenderTerraformWorkspace,
} from './components/utils';

export {
  shouldRenderHerokuInfo,
  shouldRenderPagerDutyInfo,
  shouldRenderTerraformWorkspace,
};

export const herokuIdpCatalogPlugin = createPlugin({
  id: 'heroku-idp-catalog',
  routes: {
    root: rootRouteRef,
  },
});

export const HerokuIdpCatalogCard = herokuIdpCatalogPlugin.provide(
  createComponentExtension({
    name: 'HerokuIdpCatalogCard',
    component: {
      lazy: () =>
        import('./components/HerokuIdpCatalogCard').then(
          m => m.HerokuIdpCatalogCard,
        ),
    },
  }),
);

export const TerraformWorkspaceCard = herokuIdpCatalogPlugin.provide(
  createComponentExtension({
    name: 'TerraformWorkspaceCard',
    component: {
      lazy: () =>
        import('./components/TerraformWorkspaceCard').then(
          m => m.TerraformWorkspaceCard,
        ),
    },
  }),
);
